import { SavedView } from 'models/saved_view'
import { toast } from 'react-toastify'
import useApiService from 'services/api'
import { invalidateSavedFilterQueries } from 'services/saved_filters'
import { SavedFilterFormData, SavedFilterModal } from './SavedFilterModal'

interface EditSavedFilterModalProps {
  show: boolean
  handleClose: () => void
  savedFilter: SavedView | null
  onFilterUpdated?: () => void
}

export function EditSavedFilterModal({
  show,
  handleClose,
  savedFilter,
  onFilterUpdated,
}: EditSavedFilterModalProps) {
  const api = useApiService()

  const handleSubmitSuccess = () => {
    toast.success('Filter updated!')
    onFilterUpdated?.()
  }

  const updateFilter = async (values: SavedFilterFormData) => {
    if (!savedFilter) return

    await api.updateFilter(savedFilter.id, {
      name: values.name,
      shared: values.shared,
    })

    await invalidateSavedFilterQueries(savedFilter.identifier)
  }

  return (
    <SavedFilterModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Update"
      submitApiAction={updateFilter}
      savedFilterToEdit={savedFilter}
      title="Edit Filter"
      description="Update the filter name and sharing settings."
    />
  )
}
